import { render, staticRenderFns } from "./filter-items.vue?vue&type=template&id=c5f2933c&"
import script from "./filter-items.vue?vue&type=script&lang=js&"
export * from "./filter-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports